import { BUCKET_PREFIX } from '../utils/environment';

export const RIVE_CANVAS_VERSION = '2.37.6';

export const RIVE_WASM_RESOURCE = `${BUCKET_PREFIX}/rive-wasm/rive-app-canvas-${RIVE_CANVAS_VERSION}.wasm`;
